import React from "react";

interface ABTestProps {
  experimentId: string;
  defaultVariationId: string;
  variations: Array<{ variationId: string; component: React.ReactElement }>;
  fallback: React.ReactElement;
}

interface ActiveExperiment {
  variation_id: string;
  variation_name_parts: {
    sections: string[];
    changes: string[]; 
  };
  variation_name: string;
  first_time: boolean;
}

type WindowWithDataLayer = Window & {
  convert: {
    currentData: {
      experiments: {
        [experimentId: string]: ActiveExperiment;
      }
    }
    data: {
      experiments: Record<string, { vars: Record<string, any> }>;
    };
  };
};

declare const window: WindowWithDataLayer;

function ABTestContainer(props: ABTestProps) {
  const { experimentId, defaultVariationId, variations, fallback } = props;

  const getVariation = () => {
    const activeExperiments = window?.convert?.currentData?.experiments;
    const isExperimentActive = activeExperiments?.hasOwnProperty(experimentId);
    let variationId = '';

    if (isExperimentActive) {
      // Get current variation ID from the active experiment
      variationId = window.convert.currentData.experiments[experimentId].variation_id
    } else {
      variationId = defaultVariationId;
    }
    const variation = variations.find(variation => variation.variationId === variationId);
    return variation ? variation.component : null;
  }

  const variationComponent = getVariation();
  if (!variationComponent) {
    return fallback;
  }

  return (
    <React.Fragment>
      {variationComponent}
    </React.Fragment>
  );
}

export default ABTestContainer;